import React from 'react';
import { Text } from '@mantine/core';
import { SectionGroupNode, SectionStatus, getSectionNavKey, getSectionNavLabel } from './form-helpers';
import styles from './FormTableOfContents.module.css';

export interface FormTableOfContentsProps {
    sections: SectionGroupNode[];
    statusesByKey: Record<string, SectionStatus>;
    activeKey: string | null;
    onNavigate: (key: string) => void;
}

function sectionLabel(section: SectionGroupNode, sections: SectionGroupNode[]): string {
    if (section.sectionID === null) return 'General';
    return getSectionNavLabel(section, sections);
}

function FormTableOfContents({ sections, statusesByKey, activeKey, onNavigate }: FormTableOfContentsProps) {
    return (
        <nav className={styles.nav} aria-label="Form sections">
            {sections.map((section) => {
                const key = getSectionNavKey(section);
                const status = statusesByKey[key] ?? 'empty';
                const isActive = key === activeKey;
                return (
                    <div
                        key={key}
                        role="button"
                        tabIndex={0}
                        className={isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem}
                        onClick={() => onNavigate(key)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onNavigate(key); }}
                    >
                        <span className={styles.statusDot} data-status={status} />
                        <Text size="sm" fw={isActive ? 700 : 400} className={styles.navLabel}>{sectionLabel(section, sections)}</Text>
                    </div>
                );
            })}
        </nav>
    );
}

export default React.memo(FormTableOfContents);
